// extracted by mini-css-extract-plugin
export default {"auth":"styles_auth__SsIbI","spinner":"styles_spinner__bm6iR","spin":"styles_spin__mcukc"};